import { render, staticRenderFns } from "./ocrExceptPage.vue?vue&type=template&id=3e5805b0"
import script from "./ocrExceptPage.vue?vue&type=script&lang=js"
export * from "./ocrExceptPage.vue?vue&type=script&lang=js"
import style0 from "./ocrExceptPage.vue?vue&type=style&index=0&id=3e5805b0&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports